import React, { useEffect } from "react";
import "./CustomModalStyle.scss";
import { motion, AnimatePresence } from "framer-motion";
import CloseXIcon from "../../../assets/icons/Close-X";

const backdropVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
};

const modalVariants = {
  hidden: { opacity: 0, scale: 0.9, y: -50 },
  visible: { opacity: 1, scale: 1, y: 0 },
  exit: { opacity: 0, scale: 0.9, y: -50 },
};

function CustomModal({ isOpen, onClose, children, title }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="custom-modal-wrapper">
          <motion.div
            className="custom-modal-backdrop"
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={backdropVariants}
            onClick={onClose}
          />

          <div className="custom-modal-box">
            <motion.div
              className="custom-modal"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={modalVariants}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              {/* Header */}
              <div className="custom-modal-header">
                <h3 className="custom-modal-title-text">{title}</h3>
                <button className="close-btn" onClick={onClose}>
                  <CloseXIcon />
                </button>
              </div>

              {/* Body */}
              <div className="custom-modal-body">{children}</div>
            </motion.div>
          </div>
        </div>
      )}
    </AnimatePresence>
  );
}

export default CustomModal;
